function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { path } from 'ramda';
import { IsPanelVisibleSelector, RecentCustomersSelector } from '../../reducers/selectors/recent.customers.selectors';
import { routeToCustomer } from '../../reducers/actions/search.customer.actions';
import { hideRecentCustomersPanel } from '../../reducers/actions/recent.customers.actions';
import CustomerCareLocaleKeys from '../../locales/keys';
import PanelAutoClose from 'invision-core/src/utilities/panel.auto.close.handler';
export var RecentCustomersController = /*#__PURE__*/function () {
  function RecentCustomersController($ngRedux) {
    _classCallCheck(this, RecentCustomersController);
    this.$ngRedux = $ngRedux;
  }
  return _createClass(RecentCustomersController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        hideRecentCustomersPanel: hideRecentCustomersPanel,
        routeToCustomer: routeToCustomer
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          customers: RecentCustomersSelector(store),
          isRecentCustomersVisible: IsPanelVisibleSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.customerClicked = function (customer) {
        _this.actions.routeToCustomer(customer);
        _this.actions.hideRecentCustomersPanel();
      };
      this.customerCareLocaleKeys = CustomerCareLocaleKeys;
      this.isRecentCustomersHidden = function () {
        return !path(['state', 'isRecentCustomersVisible'], _this);
      };
      this.recentCustomersEvent = PanelAutoClose.autoCloseRegistration({
        element: 'recent-customers',
        toggleButtonElement: '#navigator-item-recentCustomers',
        isHidden: this.isRecentCustomersHidden,
        callback: this.actions.hideRecentCustomersPanel
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      PanelAutoClose.unregister(this.recentCustomersEvent);
    }
  }]);
}();
export default {
  template: require('./recent.customers.html'),
  controller: RecentCustomersController,
  controllerAs: 'RecentCustomers',
  bindings: {
    isVisible: '<'
  }
};